module.exports = __webpack_public_path__ + "img/veg.7868d208.png";